import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { AppState } from '../../../../@store/app.reducers';
import { Store } from '@ngrx/store';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { selectListaCatalogosTerceroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { debounceTime, distinctUntilChanged, filter, Subscription } from 'rxjs';
import { ComplementoWebService } from '../../../../services/complemento-web/complemento-web.service';
import { ActivarLoadingAction, DesactivarLoadingAction } from '../../../../@store/actions';
import { ConsultaModelosOutput, ConsultaVehiculosOutput, DatoGenerico, ModeloVehiculo, Vehiculo } from '../../../../models/complementos-web/complementos-web-terceros.model';
import { ResultApiResponse } from '../../../../models/complementos-web/complementos-web-servicios.model';
import { MatPaginator } from '@angular/material/paginator';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { NgClass } from '@angular/common';
import { MatInput } from '@angular/material/input';

@Component({
    selector: 'app-modal-consultar-vehiculos',
    templateUrl: './modal-consultar-vehiculos.component.html',
    styleUrls: ['./modal-consultar-vehiculos.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption, MatInput, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow, NgClass, MatPaginator]
})
export class ModalConsultarVehiculosComponent implements OnInit, OnDestroy {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  public formConsultaVehiculo: FormGroup;

  public catCategoria: DatoGenerico[] = [];
  public catModelo: ModeloVehiculo[] = [];

  public displayColumns = ['Marca', 'Subtipo', 'Descripcion'];
  public datosVehiculos = new MatTableDataSource<Vehiculo>([]);
  public selectVehiculoDatos: Vehiculo | null = null;

  private listaObservables = new Subscription();

  constructor(
    public dialogRef: MatDialogRef<ModalConsultarVehiculosComponent>,
    private store: Store<AppState>,
    private complementoWebService: ComplementoWebService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.cargarFormulario();
    this.obtenerCatalogos();
  }

  ngOnInit(): void {
    this.cambiosFormulario();
    if (this.data.categoria) {
      this.formConsultaVehiculo.get('categoria').setValue(this.data.categoria);
    }
  }

  ngOnDestroy(): void {
    this.listaObservables.unsubscribe();
  }

  obtenerCatalogos() {
    this.store.select(selectListaCatalogosTerceroSiniestros).subscribe({
      next: (value) => {
        this.catCategoria = value.consultaCategorias;
      },
    });
  }

  closeDialog(opcion: string, valor?) {
    if (opcion == 'Cancelar') this.dialogRef.close(valor);
    if (opcion == 'Aceptar') this.dialogRef.close(valor);
  }

  cargarFormulario() {
    this.formConsultaVehiculo = new FormGroup({
      categoria: new FormControl(null),
      modelo: new FormControl(null),
      descripcion: new FormControl(null),
    });
  }

  cambiosFormulario() {
    const subsCategoria = this.formConsultaVehiculo.get('categoria')?.valueChanges.subscribe({
      next: (value) => {
        this.formConsultaVehiculo.get('modelo').setValue(null, { emitEvent: false });
        this.formConsultaVehiculo.get('descripcion').setValue(null, { emitEvent: false });
        this.obtenerModelosPorCategoria(value);
      },
    });
    const subsModelo = this.formConsultaVehiculo.get('modelo')?.valueChanges.pipe(debounceTime(100)).subscribe({
      next: (value) => {
        this.formConsultaVehiculo.get('descripcion').setValue(null, { emitEvent: false });
      },
    });
    const subsDescripcion = this.formConsultaVehiculo.get('descripcion')?.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter(value => value && value.length > 1)
    ).subscribe({
      next: (value) => {
        const { categoria, modelo } = this.formConsultaVehiculo.getRawValue();
        this.obtenerVehiculosPorModeloCategoria(categoria, modelo, value);
      },
    });
    this.listaObservables.add(subsCategoria);
    this.listaObservables.add(subsModelo);
    this.listaObservables.add(subsDescripcion);
  }

  obtenerModelosPorCategoria(categoria: number) {
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaModelos({ categoria }).subscribe({
      next: (value: ResultApiResponse<ConsultaModelosOutput>) => {
        this.catModelo = value.Resultado.Modelos;
      },
      complete: () => {
        this.store.dispatch(DesactivarLoadingAction());
      },
    })
  }

  obtenerVehiculosPorModeloCategoria(categoria: number, modelos: number, descripcion: string) {
    this.store.dispatch(ActivarLoadingAction());
    const request = {
      categoria,
      modelo: modelos,
      marca: null,
      subTipo: null,
      descripcion
    };
    this.complementoWebService.consultaVehiculos(request).subscribe({
      next: (value: ResultApiResponse<ConsultaVehiculosOutput>) => {
        this.datosVehiculos = new MatTableDataSource(value.Resultado.Vehiculos ?? []);
        this.datosVehiculos.paginator = this.paginator;
      },
      complete: () => {
        this.store.dispatch(DesactivarLoadingAction());
      },
    })
  }

  seleccionarVehiculo(vehiculo: Vehiculo) {
    this.selectVehiculoDatos = vehiculo;
    this.closeDialog('Aceptar', {
      ...this.selectVehiculoDatos,
      ...this.formConsultaVehiculo.getRawValue()
    });
  }
}
